import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { PlacementArray } from '@ng-bootstrap/ng-bootstrap/util/positioning';

@Component({
  selector: 'app-header-info-title',
  templateUrl: './header-info-title.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderInfoTitleComponent {
  @HostBinding('class')
  private readonly classes = 'block';

  @Input()
  headerText: string;

  @Input()
  infoText: string;

  @Input()
  tooltipPosition: PlacementArray = 'right';
}
